import { RootState } from "@store/store";
import { AudioMediaFile } from "@dto/AudioMediaFile";
import { VideoMediaFile } from "@dto/VideoMediaFile";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MediaReducerState {
  isPlaying: boolean;
  mediaFile: ((AudioMediaFile | VideoMediaFile) & { title: string }) | null;
  isMediaTranscriptOpen: boolean;
  mediaTranscript: {
    title: string;
    transcript: string;
  } | null;
}

const initialState: MediaReducerState = {
  isPlaying: false,
  isMediaTranscriptOpen: false,
  mediaFile: null,
  mediaTranscript: null,
};

const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setMediaAction: (
      state: MediaReducerState,
      action: PayloadAction<
        ((AudioMediaFile | VideoMediaFile) & { title: string }) | null
      >,
    ) => {
      state.mediaFile = action.payload;
      state.isPlaying = false;
    },
    setIsPlayingAction: (
      state: MediaReducerState,
      action: PayloadAction<boolean>,
    ) => {
      state.isPlaying = action.payload;
    },
    setMediaTranscriptAction: (
      state: MediaReducerState,
      action: PayloadAction<{
        title: string;
        transcript: string;
      } | null>,
    ) => {
      state.mediaTranscript = action.payload;
    },
  },
});

export const selectMediaFile = (state: RootState) => {
  return state.media.mediaFile;
};

export const selectIsPlaying = (state: RootState) => {
  return state.media.isPlaying;
};

export const selectMediaTranscript = (state: RootState) => {
  return state.media.mediaTranscript;
};

export const selectIsPlayingMedia =
  (uri: string | undefined) => (state: RootState) => {
    if (!uri) {
      return false;
    }

    return (
      state.media.isPlaying &&
      ((state.media.mediaFile as AudioMediaFile)?.url === uri ||
        (state.media.mediaFile as VideoMediaFile)?.streamUrl === uri)
    );
  };

export const selectIsMediaActive =
  (uri: string | undefined) => (state: RootState) => {
    if (!uri) {
      return false;
    }

    return (
      (state.media.mediaFile as AudioMediaFile)?.url === uri ||
      (state.media.mediaFile as VideoMediaFile)?.streamUrl === uri
    );
  };

export const { setMediaAction, setIsPlayingAction, setMediaTranscriptAction } =
  mediaSlice.actions;

// eslint-disable-next-line import/no-default-export
export default mediaSlice.reducer;
